import { makeAutoObservable, runInAction } from "mobx";
import { RootStore } from "@intrasync/stores";

export default class ProductManagementStore {
    // Observables
    isLoading = false;
    error: string | null = null;
    products: any[] = [];
    categories: any[] = [];
    currentProduct: any = null;

    // Constructor
    constructor(private rootStore: RootStore) {
        makeAutoObservable(this);
    }

    // Actions
    setLoading(loading: boolean) {
        this.isLoading = loading;
    }

    setError(error: string | null) {
        this.error = error;
    }

    // Async actions
    async loadProducts(productId?: string) {
        try {
            this.setLoading(true);
            this.setError(null);

            // Mock data for now
            const mockProducts = [
                {
                    id: "product-1",
                    name: "Standard Wall Panel",
                    category: "Wall Panels",
                    description: "Standard precast wall panel",
                    status: "Active",
                },
                {
                    id: "product-2",
                    name: "Standard Floor Panel",
                    category: "Floor Panels",
                    description: "Standard precast floor panel",
                    status: "Active",
                },
            ];

            runInAction(() => {
                this.products = mockProducts;
                if (productId) {
                    this.currentProduct = mockProducts.find(p => p.id === productId) || null;
                }
            });
        } catch (error: any) {
            runInAction(() => {
                this.setError(error.message || "Failed to load products");
            });
        } finally {
            this.setLoading(false);
        }
    }

    // Computed values
    get hasProducts() {
        return this.products.length > 0;
    }
}
